var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"app-overview-item"},[_c('span',{staticClass:"app-overview-item__label"},[_c('app-text-help',{attrs:{"text":_vm.label,"tip":_vm.tip}})],1),_c('span',{staticClass:"app-overview-item__value"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }